import {
  KMH_PER_MPS,
  type Device,
  type GpsReading,
  type RawTelemetryData,
  calculateDistance,
  deviceMetadataOf,
} from '@pitbrain/shared'

interface KmhRow {
  latitude: number
  longitude: number
  altitude?: number
  speed?: number | null
  date: Date | string
}

export const withRunningDistance = (
  readings: Array<Omit<GpsReading, 'distanceMeters'>>
): GpsReading[] => {
  let totalDistance = 0
  return readings.map((reading, index) => {
    if (index > 0) {
      const previous = readings[index - 1]
      totalDistance += calculateDistance(
        previous.latitude,
        previous.longitude,
        reading.latitude,
        reading.longitude
      )
    }
    return { ...reading, distanceMeters: totalDistance }
  })
}

export const rawTelemetryFromKmhRows = (
  rows: KmhRow[],
  device: Device
): RawTelemetryData => {
  const gps = withRunningDistance(
    rows.map((row) => ({
      latitude: row.latitude,
      longitude: row.longitude,
      altitude: row.altitude,
      speedMs: row.speed != null ? row.speed / KMH_PER_MPS : undefined,
      timestamp: new Date(row.date),
    }))
  )
  return {
    gps,
    gyroscope: undefined,
    accelerometer: undefined,
    recordingStartTime: gps[0]?.timestamp,
    device: deviceMetadataOf(device),
  }
}
